<template>
	<div>
		<b-container>
			<b-breadcrumb :items="breadcrumb" style="margin-top: 15px;"></b-breadcrumb>
			<b-row style="margin: 10px 0px 10px 0px; padding: 0px;">
				<b-col cols="3" style="padding-left:0px;">
					<b-button variant="primary" block class="title" @click="newWorker"> {{$lang.worker.new}}</b-button>
				</b-col>
				<b-col cols="9" style="padding-right: 0px;" >
					<b-input-group >
						<b-input :placeholder="$lang.common.search"/>
						<b-input-group-append>
							<b-button variant="outline-primary">{{ $lang.common.search }}</b-button>
						</b-input-group-append>
					</b-input-group>
				</b-col>
			</b-row>
			<b-table striped hover outlined :items="$store.state.workers.workers" :fields="fields" @row-clicked="editWorker" style="cursor:pointer">
				<template v-slot:cell(index)="data">
					{{ data.index + 1 }}
				</template>

				<template v-slot:cell(name)="data">
					{{ data.item.firstName + ' ' + data.item.lastName }}
				</template>

				<template v-slot:cell(isActive)="data">
					{{ data.value == true ? $lang.worker.status.active : $lang.worker.status.inactive }}
				</template>

				<template v-slot:cell(endDate)="data">
					{{ data.item.contract.type.type == 'undefined' ? 'N/A' : data.value }}
				</template>

				<template v-slot:cell(advancedInfo)="row">
					<div >
						<p-check class="p-switch p-fill" color="info" v-model="row.detailsShowing" @change="row.toggleDetails">{{ row.detailsShowing ? $lang.common.more : $lang.common.less}}</p-check>
					</div>
				</template>

				<template v-slot:row-details="row">
					<b-card>
						<b-row align-h="end">
							<b-button size="sm" @click="row.toggleDetails" class="mb-12 text-right"><font-awesome-icon icon="minus" /> {{$lang.common.less}}</b-button>
						</b-row>

						<b-row class="mb-2">
							<b-col sm="3" class="text-sm-right"><b>{{$lang.worker.birthDate + ':'}} </b></b-col>
							<b-col>{{ row.item.birthDate }}</b-col>
						</b-row>

						<b-row class="mb-2">
							<b-col sm="3" class="text-sm-right"><b>{{$lang.worker.email + ':'}}</b></b-col>
							<b-col sm="3">{{ row.item.email }}</b-col>
							<b-col sm="3" class="text-sm-right"><b>{{$lang.worker.phoneNumber + ':'}}</b></b-col>
							<b-col sm="3">{{ row.item.phoneNumber }}</b-col>
						</b-row>

						<b-row class="mb-2">
							<b-col sm="3" class="text-sm-right"><b>{{$lang.contract.startDate + ':'}}</b></b-col>
							<b-col sm="3">{{ moment(row.item.contract.startDate).format(dateFormat) }}</b-col>
							<b-col sm="3" class="text-sm-right"><b>{{$lang.contract.endDate + ':'}}</b></b-col>
							<b-col sm="3">{{ moment(row.item.contract.endDate).format(dateFormat) }}</b-col>
						</b-row>

						<b-row class="mb-2">
							<b-col sm="3" class="text-sm-right"><b>{{$lang.contract.salary + ':'}}</b></b-col>
							<b-col sm="3">{{ row.item.contract.salary }}</b-col>
							<b-col sm="3" class="text-sm-right"><b>{{$lang.contract.position + ':'}}</b></b-col>
							<b-col sm="3">{{ row.item.contract.position.name }}</b-col>
						</b-row>

					</b-card>
				</template>
			</b-table>
			<b-button variant="primary" class="title" block value="Save" v-on:click="loadMore" v-if="$store.state.workers.workersPagination.showLoadMore == true">{{$lang.buttons.loadMore}}</b-button>
		</b-container>
	</div>

</template>

<script>
import { mapState } from 'vuex'
import { dateFormat } from '../../utils.js'

export default {
	data() {
		return {
			fields: [
				{key: 'index', label: '#'},
				{
					key: 'idNumber',
					label: this.$lang.worker.idNumber,
					sortable: true,
				},
				{
					key: 'name',
					label: this.$lang.worker.name
				},
				{
					key: 'isActive',
					label: this.$lang.worker.workerStatus,
					sortable: false
				},
				{
					key: 'contract.type.name',
					label: this.$lang.contract.title
				},
				{
					key: 'contract.endDate',
					label: this.$lang.contract.endDate,
				},
				{
					key: 'advancedInfo',
					label: this.$lang.worker.showAdvancedDetails
				}
			],
			breadcrumb: [{'text': this.$lang.worker.moduleName,'to': '/workers'},{'text': this.$lang.worker.list,'to': '#'}],
			dateFormat: dateFormat

		}
	},
	computed: {
		...mapState(['currentUser']),
	},
	methods: {
		editWorker(worker) {
			this.$router.push({ name: 'WorkersEdit', params: { workerId: worker.id } })
		},
		newWorker() {
			this.$router.push({ name: 'WorkersNew' })
		},
		loadMore() {
			let currentPagination = this.$store.getters.workersPagination;
			this.$store.dispatch('updateWorkersPagination', {page: currentPagination.page++, ...currentPagination});
			this.$store.dispatch('fetchWorkers')
		}
	},
	created() { // TAKES PRIORITY WHEN RENDERING DOM
		this.$Progress.start()
		console.log(this.$store.state)
		this.$store.dispatch('updateWorkersPagination', { page:1, ...this.$store.getters.workersPagination });
		this.$store.dispatch('fetchWorkers')
		this.$Progress.finish();
	}
}

</script>